module.exports = __webpack_public_path__ + "img/about_story.c67d6663.png";